import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItemText, Select, FormControl, MenuItem, createStyles, Theme as AugmentedTheme} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';

interface ISelect {
    field: CustomInputMappingField,
    value: string,
    selectChangeHandler: (val: string) => void,
    setCondition: (val: string) => void,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    select: {
        position: 'relative',
        width: '100%',
        padding: '8px 10px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: '-webkit-fill-available',
        [theme.breakpoints.down('sm')]: {
            minWidth: 'unset!important',
        }
      },
    optionsList: {
        paddingTop: 2.5,
        paddingBottom: 2.5
    },
}))

export default function SelectInput({ field, value, selectChangeHandler , setCondition,isRtl}: ISelect) {
    const classes = useStyles();

    const [options, setOptions] = useState<string[]>([]);

    const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
        selectChangeHandler(e.target.value as string);
        setCondition(e.target.value as string)
    }

    useEffect(() => {
        if(field.options) {
            const selectOptions = field.options?.split(';');
            setOptions(selectOptions);
        }
    }, [field.options])


    return(
        <FormControl className={classes.formControl}>
            <Select
                  style={{ 
                    direction: isRtl ? 'rtl' : 'ltr',
                    textAlign: isRtl ? 'right' : 'left' 
                }} 
                value={value}
                displayEmpty
                onChange={handleChange}
                required={field.required}
                classes={{ select: `${classes.select}` }}
                inputProps={{ 'aria-label': 'Without label' }}
                MenuProps={{classes: {list: classes.optionsList}}}          
            >
                <MenuItem 
                value="" disabled>
                    {field.fieldName}
                </MenuItem>
                {options.map((item: any) => (
                        <MenuItem
                         key={item.trim()} value={item.trim()}>
                            <ListItemText 
                            primary={item} />
                        </MenuItem>
                ))}
        </Select>
      </FormControl>
    )
}
